import { render } from "./CambiarOrdenAreas.vue?vue&type=template&id=692f333b&scoped=true&ts=true"
import script from "./CambiarOrdenAreas.vue?vue&type=script&lang=ts"
export * from "./CambiarOrdenAreas.vue?vue&type=script&lang=ts"

import "./CambiarOrdenAreas.vue?vue&type=style&index=0&id=692f333b&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692f333b"]])

export default __exports__